import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "title"]

  mouseEnter() {
    this.iconTarget.classList.replace("ph", "ph-fill")
    this.titleTarget.classList.replace("text-[#1F4D64]", "text-[#FF6B5E]")
  }

  mouseLeave() {
    this.iconTarget.classList.replace("ph-fill", "ph")
    this.titleTarget.classList.replace("text-[#FF6B5E]", "text-[#1F4D64]")
  }
}
